import { ref, onMounted, computed } from 'vue';
import Sortable from 'sortablejs';
import Swal from 'sweetalert2';
import Sidebar from '@/components/Sidebar.vue';
import Header from '@/components/HeaderDashboard.vue';
import { RepuestoService } from '@/services/RepuestoService';
import { AtributoService } from '@/services/AtributoService';
import { PlusIcon, EditIcon, TrashIcon } from 'lucide-vue-next';
import { useRouter } from "vue-router";
export default {
    name: 'Marcas',
    components: {
        Sidebar,
        Header,
        PlusIcon,
        EditIcon,
        TrashIcon
    },
    setup() {
        const router = useRouter();
        const user = ref(null);
        const searchRepuestos = ref('');
        const repuestos = ref([]);
        const selectedRepuesto = ref(null);
        const filteredRepuestos = computed(() => {
            if (searchRepuestos.value.length < 3)
                return [];
            return repuestos.value.filter((repuesto) => repuesto.nombre.toLowerCase().includes(searchRepuestos.value.toLowerCase()));
        });
        const desplegables = ref([]);
        const valores = ref([]);
        const isModalOpen = ref(false);
        const currentDesplegable = ref(null);
        const fetchRepuestos = async () => {
            try {
                repuestos.value = await RepuestoService.getAllRepuestos();
            }
            catch (error) {
                console.error('Error al cargar repuestos:', error);
            }
        };
        const fetchValores = async (atributoID) => {
            try {
                //valores.value = await AtributoService.getValoresByAtributoId(atributoID);
                //initSortableValores();
            }
            catch (error) {
                console.error('Error al cargar valores:', error);
            }
        };
        const fetchDesplegables = async (repuestoID) => {
            try {
                desplegables.value = await AtributoService.getAtributosByRepuestoId(repuestoID);
                initSortable(); // Inicializa drag-and-drop
            }
            catch (error) {
                console.error('Error al cargar desplegables:', error);
            }
        };
        const selectRepuesto = (repuesto) => {
            searchRepuestos.value = repuesto.nombre;
            selectedRepuesto.value = repuesto.repuestoID;
            fetchDesplegables(repuesto.repuestoID);
            repuestos.value = [];
        };
        function searchRepuesto() {
            if (searchRepuestos.value.length >= 3) {
                fetchRepuestos();
            }
            else {
                repuestos.value = [];
            }
        }
        const openModal = (desplegable) => {
            console.log('Abriendo modal para:', desplegable); // Debug
            if (!desplegable) {
                console.error('El desplegable no es válido');
                return;
            }
            currentDesplegable.value = desplegable;
            isModalOpen.value = true;
            fetchValores(desplegable.atributoID);
        };
        const closeModal = () => {
            isModalOpen.value = false;
            currentDesplegable.value = null;
        };
        const saveValoresOrder = async () => {
            const orderPayload = valores.value.map((item, index) => ({
                valorID: item.valorID,
                orden: index + 1,
            }));
            try {
                // await AtributoService.updateValoresOrder(orderPayload);
                Swal.fire('Orden actualizado', 'Los cambios han sido guardados.', 'success');
                closeModal();
            }
            catch (error) {
                Swal.fire('Error', 'No se pudo guardar el orden.', 'error');
            }
        };
        const initSortable = () => {
            const el = document.getElementById('sortable');
            if (!el)
                return;
            Sortable.create(el, {
                animation: 150,
                ghostClass: 'sortable-ghost', // Clase para el clon mientras se mueve
                chosenClass: 'sortable-chosen', // Clase para el elemento seleccionado
                onEnd: async (evt) => {
                    if (evt.oldIndex === undefined || evt.newIndex === undefined)
                        return;
                    const movedItem = desplegables.value.splice(evt.oldIndex, 1)[0];
                    desplegables.value.splice(evt.newIndex, 0, movedItem);
                    await saveOrder(); // Guarda el nuevo orden
                },
            });
        };
        const saveOrder = async () => {
            try {
                // Mostrar un cuadro de diálogo para confirmar
                const result = await Swal.fire({
                    title: '¿Estás seguro?',
                    text: '¿Deseas guardar el nuevo orden?',
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'Sí, guardar',
                    cancelButtonText: 'Cancelar',
                    customClass: {
                        confirmButton: 'swal-button--confirm-custom',
                        cancelButton: 'swal-button--cancel-custom'
                    }
                });
                if (!result.isConfirmed) {
                    console.log('El usuario canceló la actualización del orden.');
                    return;
                }
                for (const [index, item] of desplegables.value.entries()) {
                    const nuevoOrden = index + 1; // Define el nuevo orden
                    console.log(`Actualizando atributoID: ${item.atributoID} con orden: ${nuevoOrden}`);
                    // Llama al servicio para actualizar el orden de cada atributo
                    await AtributoService.updateOrdenAtributo(item.atributoID, nuevoOrden);
                }
                // Actualizar la lista después de guardar
                await fetchDesplegables(selectedRepuesto.value);
                Swal.fire('Orden actualizado', 'Los cambios han sido guardados.', 'success');
            }
            catch (error) {
                console.error('Error al guardar el orden:', error);
                Swal.fire('Error', 'No se pudo guardar el orden.', 'error');
            }
        };
        onMounted(() => {
            fetchRepuestos();
        });
        return {
            searchRepuestos,
            searchRepuesto,
            filteredRepuestos,
            desplegables,
            selectRepuesto,
            selectedRepuesto,
            valores,
            isModalOpen,
            currentDesplegable,
            openModal,
            closeModal,
            saveValoresOrder,
        };
    },
};
